import { MapMarker } from '@library/components/maps';
import MapMarkerOrangeIcon from '@library/assets/images/icons/map-marker-orange.svg';
import { MemberProfileMapContext } from '@bo-hooks/members/useMemberProfileMapContext';
import { NavLink } from 'react-router-dom';
import { useContext } from 'react';

export const MemberProfileMapMarkers = () => {
  const { mapPoints, markerType } = useContext(MemberProfileMapContext);

  const rendersEntries = () =>
    mapPoints.map((point) => {
      const { markers, position } = point;

      return (
        <MapMarker key={position.join('-')} position={position}>
          <div className="flex max-h-64 flex-col gap-2 overflow-y-auto">
            {markers.map(({ id, createdAtDisplay }) => (
              <div className="flex items-center" key={id}>
                <NavLink className="pr-1" to={`../entries/?entryId=${id}`}>
                  {id}
                </NavLink>
                <span> - {createdAtDisplay}</span>
              </div>
            ))}
          </div>
        </MapMarker>
      );
    });

  const renderSignIns = () =>
    mapPoints.map((point) => {
      const { markers, position } = point;

      return (
        <MapMarker
          key={position.join('-')}
          position={position}
          markerIcon={MapMarkerOrangeIcon}
        >
          <div className="flex max-h-64 flex-col gap-2 overflow-y-auto">
            {markers.map(({ id, createdAtDisplay }) => (
              <div key={id}>{createdAtDisplay}</div>
            ))}
          </div>
        </MapMarker>
      );
    });

  return markerType === 'ENTRIES' ? rendersEntries() : renderSignIns();
};
